module.exports = __webpack_public_path__ + "files/SPIADI2026 - Journée Nationale - Bulletin d'inscription.b8b7995b6d99915e358e817c3a85191f.pdf";